var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagZambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2609 16H16V32C17.8702 32 19.6651 31.6781 21.3333 31.0884L22.2609 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 27.9246C29.9396 24.9949 32 20.7383 32 16H25.7391L26.6666 27.9246Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.333 16V31.0884C23.3203 30.3858 25.1274 29.3021 26.6664 27.9246V16H21.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5652 10.4348H25.3913C25.3913 9.66639 24.7683 9.04346 23.9999 9.04346C23.2316 9.04346 22.6086 9.66639 22.6086 10.4348H18.4347C18.4347 11.2032 19.104 11.8261 19.8723 11.8261H19.826C19.826 12.5945 20.4488 13.2174 21.2173 13.2174C21.2173 13.9858 21.8401 14.6087 22.6086 14.6087H25.3913C26.1596 14.6087 26.7826 13.9858 26.7826 13.2174C27.5509 13.2174 28.1739 12.5945 28.1739 11.8261H28.1276C28.8959 11.826 29.5652 11.2031 29.5652 10.4348Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagZambia);
export default __webpack_public_path__ + "static/media/flag_zambia.24b2a95eabe12a0380d9f5de95cd1ac2.svg";
export { ForwardRef as ReactComponent };